import { useThorEvent } from "@aviv-dxp/react-thor";
export const useTrackingSimilarListingLoad = (similarListings) => {
    const items = similarListings.map((item) => item.tracking);
    const EVENT_DATA = {
        event: "view_item_list",
        av_items: items,
        av_category: "classified",
    };
    const thorEvent = useThorEvent({
        compatibilities: { GA3: false, GA4: true },
        eventData: EVENT_DATA,
    });
    return () => thorEvent();
};
